import { getLiquidadcionesAll, getLiquidacionesClaveViaje, getLiquidadcionesAllBusqueda } from "../services/serviceViaje";
import { newCompraItemGrupalLiquidacion, getItemsPagarGrupo, newCompraItem, newCompraItemGrupalLiquidacionAmount} from "../services/comprasService";
import {catTipoCompra} from "./../constant/catTipoCompra"
const dataInicial = {
    liquidaciones: [],
    grupos: [],
    total: 0,
    pagina: 0,
    registroPagina: 10,
    exito: 0,
    grupo: {},
    calculo: {},
    grupoValido: true,
    moneda: {},
    busqueda: 'NA',
    montoTotalCal: 0
};

const GET_LIQUIDACIONES_ALL = "GET_LIQUIDACIONES_ALL"
const GET_LIQUIDACIONES_BUSQUEDA_ALL = "GET_LIQUIDACIONES_BUSQUEDA_ALL"
const GET_LIQUIDACIONES_REGISTROS_PAGINA = "GET_LIQUIDACIONES_REGISTROS_PAGINA"
const GET_LIQUIDACIONES_PAGINA = "GET_LIQUIDACIONES_PAGINA"
const POST_LIQUIDACIONES_EXITO = "POST_LIQUIDACIONES_EXITO"
const POST_LIQUIDACIONES_NEW_ITEM = "POST_LIQUIDACIONES_NEW_ITEM"
const PUT_LIQUIDACIONES_AUTORIZADO_EXITO = "PUT_LIQUIDACIONES_AUTORIZADO_EXITO"
const GET_LIQUIDACIONES_GRUPOS_CLAVE = "GET_LIQUIDACIONES_GRUPOS_CLAVE"
const SELECT_LIQUIDACIONES_GRUPO = "SELECT_LIQUIDACIONES_GRUPO"
const GET_LIQUIDACIONES_GRUPO_CALCULO = "GET_LIQUIDACIONES_GRUPO_CALCULO"
const CLEAR_LIQUIDACIONES_STATE = "CLEAR_LIQUIDACIONES_STATE"
const POST_LIQUIDACIONES_EXITO_CONSULTA = "POST_LIQUIDACIONES_EXITO_CONSULTA"
export default function liquidacionesReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_LIQUIDACIONES_GRUPO_CALCULO:
            return { ...state, calculo: action.payload.calculo }
        case SELECT_LIQUIDACIONES_GRUPO:
            return { ...state, grupo: action.payload.grupo }
        case GET_LIQUIDACIONES_GRUPOS_CLAVE:
            return {
                ...state,
                grupos: action.payload.grupos,
                grupo: action.payload.grupo,
                grupoValido: action.payload.grupoValido,
                moneda: action.payload.moneda
            }
        case GET_LIQUIDACIONES_PAGINA:
            return {
                ...state,
                liquidaciones: action.payload.liquidaciones,
                total: action.payload.total,
                pagina: action.payload.pagina,
            }
        case GET_LIQUIDACIONES_REGISTROS_PAGINA:
            return {
                ...state,
                liquidaciones: action.payload.liquidaciones,
                total: action.payload.total,
                registroPagina: action.payload.registroPagina
            }
        case GET_LIQUIDACIONES_BUSQUEDA_ALL:
            return {
                ...state,
                liquidaciones: action.payload.liquidaciones,
                total: action.payload.total,
                pagina: action.payload.pagina,
                registroPagina: action.payload.registroPagina
            }
        case POST_LIQUIDACIONES_EXITO:
            return { ...state, exito: action.payload.exito }
        case POST_LIQUIDACIONES_EXITO_CONSULTA:
            return { ...state, montoTotalCal: action.payload.montoTotalCal }
        case PUT_LIQUIDACIONES_AUTORIZADO_EXITO:
            return { ...state, exito: action.payload.exito }
        case GET_LIQUIDACIONES_ALL:
            return {
                ...state,
                liquidaciones: action.payload.liquidaciones,
                total: action.payload.total
            };
        case CLEAR_LIQUIDACIONES_STATE:
            return {
                ...state,
                liquidaciones: action.payload.liquidaciones
            }
        default:
            return state;
    }
}
export const generarLiquidacionAction = ({ idTipoCompra, ClaveViaje, CostoUnitarioAdulto, CostoUnitarioMenor, CostoUnitarioInfante, IdMoneda, CostoUnitarioCuadruple, CostoUnitarioSencilla, CostoUnitarioTriple }) => async (dispatch) => {
    return await newCompraItemGrupalLiquidacion({ idTipoCompra, ClaveViaje, CostoUnitarioAdulto, CostoUnitarioMenor, CostoUnitarioInfante, IdMoneda, CostoUnitarioCuadruple, CostoUnitarioSencilla, CostoUnitarioTriple }).then(Response => {
        dispatch({
            type: POST_LIQUIDACIONES_EXITO,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const generarLiquidacionConsultaAction = ({ idTipoCompra, ClaveViaje, CostoUnitarioAdulto, CostoUnitarioMenor, CostoUnitarioInfante, IdMoneda, CostoUnitarioCuadruple, CostoUnitarioSencilla, CostoUnitarioTriple }) => async (dispatch) => {
    return await newCompraItemGrupalLiquidacionAmount({ idTipoCompra, ClaveViaje, CostoUnitarioAdulto, CostoUnitarioMenor, CostoUnitarioInfante, IdMoneda, CostoUnitarioCuadruple, CostoUnitarioSencilla, CostoUnitarioTriple }).then(Response => {
        dispatch({
            type: POST_LIQUIDACIONES_EXITO_CONSULTA,
            payload: {
                exito: 1,
                montoTotalCal: Response.data.Monto
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const generarCompraLiquidacionAction = ({ idPaquete, idMoneda, idCuenta }) => async (dispatch) => {
    return await newCompraItem({ idTipoCompra: catTipoCompra.Liquidacion, idPaquete, idMoneda, idCuenta, MontoProveedor: 0  }).then(Response => {
        dispatch({
            type: POST_LIQUIDACIONES_NEW_ITEM,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
// export const autorizarReservaAction = ({ idCompra }) => async (dispatch) => {
//     return await updateAutorizacionCompraItem({ idCompra }).then(Response => {
//         dispatch({
//             type: PUT_LIQUIDACIONES_AUTORIZADO_EXITO,
//             payload: {
//                 exito: 1,
//             },
//         });
//         return Response
//     }).catch(Error => {
//         return Error
//     })
// }
export const obtenerGruposClaveViajeAction = ({ claveViaje }) => async (dispatch, getSate) => {
    return await getLiquidacionesClaveViaje({ ClaveViaje: claveViaje }).then(Response => {
        dispatch({
            type: GET_LIQUIDACIONES_GRUPOS_CLAVE,
            payload: {
                grupos: Response.lViajeVompra,
                grupo: { ...Response, PlazaLiquidacion: Response.totalPlazas, PlazaTotal: Response.totalCumplido, lViajeVompra: [], FechaViaje: Response.Fecha_Viaje },
                grupoValido: !Response.lViajeVompra.every(element => element?.Compra?.estatusCompra?.idEstatusCompra === 3),
                moneda: Response?.lViajeVompra[0]?.Meta?.Paquete?.MonedaProveedor
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerCalculoGruposClaveViajeAction = ({ claveViaje }) => async (dispatch, getSate) => {
    return await getItemsPagarGrupo({ idTpoCompra: 3, ClaveViaje: claveViaje }).then(Response => {
        dispatch({
            type: GET_LIQUIDACIONES_GRUPO_CALCULO,
            payload: {
                calculo: Response,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const selectliquidacionesGrupoAction = ({ grupo }) => async (dispatch, getSate) => {
    dispatch({
        type: SELECT_LIQUIDACIONES_GRUPO,
        payload: {
            grupo: grupo,
        },
    })
}
//* Liquidacion busqueda grupos
export const obtenerliquidacionesAction = () => async (dispatch, getSate) => {
    const { pagina, registroPagina, busqueda } = getSate().liquidaciones
    return await getLiquidadcionesAllBusqueda({ ClaveViaje: busqueda, Pagina: pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_LIQUIDACIONES_ALL,
            payload: {
                liquidaciones: Response.listGrupoAereo,
                total: Response.tamanio
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerliquidacionesBusquedaAction = ({ busqueda }) => async (dispatch, getSate) => {
    return await getLiquidadcionesAllBusqueda({ ClaveViaje: busqueda,  Pagina: dataInicial.pagina + 1, Registros: dataInicial.registroPagina }).then(Response => {
        dispatch({
            type: GET_LIQUIDACIONES_BUSQUEDA_ALL,
            payload: {
                liquidaciones: Response.listGrupoAereo,
                total: Response.tamanio,
                pagina: dataInicial.pagina,
                registroPagina: dataInicial.registroPagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerliquidacionesRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { pagina, busqueda} = getSate().liquidaciones
    return await getLiquidadcionesAllBusqueda({  ClaveViaje: busqueda, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_LIQUIDACIONES_REGISTROS_PAGINA,
            payload: {
                liquidaciones: Response.listGrupoAereo,
                total: Response.tamanio,
                registroPagina: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerliquidacionesPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { registroPagina, busqueda } = getSate().liquidaciones
    return await getLiquidadcionesAllBusqueda({ ClaveViaje: busqueda, Pagina: Pagina + 1, Registros: registroPagina }).then(Response => {
        console.log("🚀 ~ returnawaitgetLiquidadcionesAllBusqueda ~ Response.listGrupoAereo:", Response)
        dispatch({
            type: GET_LIQUIDACIONES_PAGINA,
            payload: {
                liquidaciones: Response.listGrupoAereo,
                total: Response.tamanio,
                pagina: Pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const clearState = () => (dispatch) => {
    dispatch({
        type: CLEAR_LIQUIDACIONES_STATE,
        payload: {
            dataInicial,
        },
    });
}